import { render } from "./TourGjz.vue?vue&type=template&id=c8430f76&scoped=true"
import script from "./TourGjz.vue?vue&type=script&lang=js"
export * from "./TourGjz.vue?vue&type=script&lang=js"

import "./TourGjz.vue?vue&type=style&index=0&id=c8430f76&scoped=true&lang=css"

import exportComponent from "E:\\virtual-weather-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8430f76"]])

export default __exports__